import { createSlice } from '@reduxjs/toolkit';
import { addNewBanner, getBanners, removeBanner } from './bannerService';

const initialState = {
  getBanners: {
    isBannerLoading: null,
    isBannerSuccess: null,
    bannerMessage: null,
    pageCount: 0,
    banners: [],
  },
  newBanner: {
    isBannerCreating: null,
    isBannerCreated: null,
    bannerCreationMsg: null,
  },
  removeBanner: {
    isRemovingBanner: null,
    isBannerRemoved: null,
    bannerRemoveMsg: null,
  },
};

const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBanners.pending, (state) => {
      state.getBanners = {
        ...initialState.getBanners,
        isBannerLoading: true,
        bannerMessage: 'Loading',
      };
    });

    builder.addCase(getBanners.rejected, (state, action) => {
      state.getBanners = {
        ...initialState.getBanners,
        isBannerLoading: false,
        isBannerSuccess: false,
        bannerMessage:
          action.payload || 'Error occurred while fetching Banners',
      };
    });

    builder.addCase(getBanners.fulfilled, (state, action) => {
      state.getBanners = {
        ...initialState.getBanners,
        isBannerLoading: false,
        isBannerSuccess: true,
        pageCount: action.payload.pageCount || 0,
        banners: action.payload || [],
      };
    });

    builder.addCase(addNewBanner.pending, (state) => {
      state.newBanner = {
        ...initialState.newBanner,
        isBannerCreating: true,
        bannerCreationMsg: 'Loading',
      };
    });

    builder.addCase(addNewBanner.rejected, (state, action) => {
      state.newBanner = {
        ...initialState.newBanner,
        isBannerCreating: false,
        isBannerCreated: false,
        bannerCreationMsg:
          action.payload || 'Error occurred while creating the banner.',
      };
    });

    builder.addCase(addNewBanner.fulfilled, (state, action) => {
      state.newBanner = {
        ...initialState.newBanner,
        isBannerCreating: false,
        isBannerCreated: true,
        bannerCreationMsg: action.payload || 'Successfully created the banner.',
      };
    });

    builder.addCase(removeBanner.pending, (state) => {
      state.removeBanner = {
        ...initialState.removeBanner,
        isRemovingBanner: true,
        bannerRemoveMsg: 'Loading',
      };
    });

    builder.addCase(removeBanner.rejected, (state, action) => {
      state.removeBanner = {
        ...initialState.removeBanner,
        isRemovingBanner: false,
        isBannerRemoved: false,
        bannerRemoveMsg:
          action.payload || 'Error occurred while remove the banner.',
      };
    });

    builder.addCase(removeBanner.fulfilled, (state, action) => {
      state.removeBanner = {
        ...initialState.removeBanner,
        isRemovingBanner: false,
        isBannerRemoved: true,
        bannerRemoveMsg: action.payload || 'Successfully Remove Banner.',
      };
    });
  },
});

export default bannerSlice.reducer;
